import { useEffect } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { useAppDispatch, useAppSelector } from "./store/types";
import CrateLayout from "./layouts/index";
import SbuxInstance from "./features/instance";
import { signIn } from "./services/auth";
import "./index.css";
import { getStatusSelector } from "./selectors/authSelector";
import { BrowserRouter } from "react-router-dom";
import theme from "./themes/sbux"; // <-- Use your custom theme

const App = () => {
  const dispatch = useAppDispatch();
  const status = useAppSelector(getStatusSelector);

  useEffect(() => {
    if (status === "idle" || status === "rejected") {
      (async () => {
        await dispatch(signIn(status));
      })();
    }
  }, [status]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        {status === "success" && (
          <CrateLayout>
            <SbuxInstance />
          </CrateLayout>
        )}
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
